<template>
  <div class="search">
    <div class="filters">
      <recipe-order />
    </div>
    <div class="content container">
      <recipe-tile
        class="search-card"
        v-for="recipe in filteredRecipes.slice(0, this.nrOfRecipesToShow)"
        :recipe="recipe"
        :key="recipe.id"
      />
    </div>
    <load-more />
  </div>
</template>

<script>
import RecipeTile from "./recipe/RecipeTile";
import RecipeOrder from "./recipe/RecipeOrder";
import LoadMore from "@/components/common/LoadMore";

export default {
  created() {
    this.$store.commit('setTitle', 'Søk')
    if(this.$store.getters.currentCategory.Name != 'Søk')
      this.$store.dispatch("setCurrentCategory", "Søk");
  },
  computed: {
    filteredRecipes() {
      return this.$store.getters.filteredRecipes;
    },
    nrOfRecipesToShow() {
      return this.$store.getters.nrOfRecipesToShow;
    }
  },
  components: {
    "recipe-tile": RecipeTile,
    "recipe-order": RecipeOrder,
    "load-more": LoadMore
  }
};
</script>

<style lang="scss">
</style>